import { Box, Button, Divider, FormControl, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

export const RefundFormDetails = ({
  demand,
  selectedType,
  error,
  onTypeChange,
  onDemandChange,
}) => {
  const types = useSelector((state) => state?.static?.refundTypes);

  return (
    <FormControl
      variant="standard"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 2,
      }}
    >
      {/* Section Demande */}
      <Box
        sx={{
          flex: '0 0 50%', // Prend 50% de l'espace
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center', // Centrage horizontal
        }}
      >
        <Typography sx={{ marginBottom: 1, textAlign: 'center' }}>
          Demande
        </Typography>
        <Box display="flex" gap={2}>
          <Button
            variant={demand === 'Remboursement' ? 'contained' : 'outlined'}
            onClick={() => {
              onTypeChange({});
              onDemandChange('Remboursement');
            }}
          >
            Remboursement
          </Button>
          <Button
            variant={demand === 'Geste commercial' ? 'contained' : 'outlined'}
            onClick={() => {
              onTypeChange({});
              onDemandChange('Geste commercial');
            }}
          >
            Geste commercial
          </Button>
        </Box>
      </Box>
      {/* Divider vertical */}
      <Divider
        orientation="vertical"
        flexItem
        sx={{
          marginX: 2,
          borderColor: 'divider',
        }}
      />
      {/* Section Type de demande */}
      <Box
        sx={{
          flex: '0 0 50%', // Prend 50% de l'espace
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center', // Centrage horizontal
        }}
      >
        <Typography
          sx={[
            {
              marginBottom: 1,
              textAlign: 'center',
            },
            error
              ? {
                  color: 'red',
                }
              : {
                  color: 'inherit',
                },
          ]}
        >
          Type de demande
          {error && <span style={{ color: 'red' }}>*</span>}{' '}
        </Typography>
        <Box display="flex" gap={2}>
          {types.map(
            (type) =>
              demand === type.demandType && (
                <Button
                  key={type._id}
                  variant={
                    selectedType?._id === type?._id ? 'contained' : 'outlined'
                  }
                  onClick={() => onTypeChange(type)}
                >
                  {type.name}
                </Button>
              )
          )}
        </Box>
      </Box>
    </FormControl>
  );
};
